import { useEffect, useState } from "react";
import localeEvent, { getLang } from "./events";

export default function useLocale() {
  const [language, setLanguage] = useState(getLang());

  useEffect(() => {
    localeEvent.listen((e) => {
      setLanguage(e.detail.language);
    });
    return () => localeEvent.remove();
  }, []);

  return {
    language,
  };
}
